import { getDicts } from '@/api/system/dict/data';
import { useDictStore } from '@/store/modules/dict';

/** 同一 store 内的字典在途请求；多组件同时挂载时共享，完成或失败后释放。 */
const pendingDictRequests = new WeakMap<ReturnType<typeof useDictStore>, Map<string, Promise<DictDataOption[]>>>();

/**
 * 获取字典数据，复用已完成缓存及同字典的在途请求，失败后允许后续调用重试。
 */
export const useDict = (...args: string[]): { [key: string]: DictDataOption[] } => {
  const res = ref<{
    [key: string]: DictDataOption[];
  }>({});
  // 保持原同步返回响应式字典对象的约定，缓存和在途请求按 store 实例隔离。
  const dictStore = useDictStore();
  let requests = pendingDictRequests.get(dictStore);
  if (!requests) {
    requests = new Map();
    pendingDictRequests.set(dictStore, requests);
  }

  args.forEach(async (dictType) => {
    res.value[dictType] = [];
    const dicts = dictStore.getDict(dictType);
    if (dicts) {
      res.value[dictType] = dicts;
      return;
    }
    try {
      let request = requests.get(dictType);
      if (!request) {
        request = getDicts(dictType).then((resp) => {
          // 只缓存成功结果；空字典同样缓存，避免每张卡片再次请求。
          const options = (resp?.data || []).map(
            (p): DictDataOption => ({ label: p.label, value: p.itemCode, elTagType: p.listClass, elTagClass: p.cssClass })
          );
          dictStore.setDict(dictType, options);
          return options;
        }).finally(() => {
          requests.delete(dictType);
        });
        requests.set(dictType, request);
      }
      res.value[dictType] = await request;
    } catch (error) {
      console.error('加载字典失败:', dictType, error);
    }
  });
  return res.value;
};

/**
 * 获取字典名称
 */
export function getDictName(list: DictDataOption[], value: string | number | Array<string | number>) {
  if (!value) return '-';
  if (!list) return value;
  if (Array.isArray(value)) {
    return list
      .filter((item) => value.includes(item.value))
      .map((item) => item.label)
      .join('、');
  }
  for (const item of list) {
    if (item.value == value) {
      return item.label;
    }
  }
}

/**
 * 获取字典名称
 */
export function getLangDictName(list: any[], value: string | number | Array<string | number>, key = 'value', label = 'label') {
  if (!list) return value;
  if (Array.isArray(value)) {
    return list
      .filter((item) => value.includes(item[key]))
      .map((item) => item[label])
      .join('、');
  }
  for (const item of list) {
    if (item[key] == value) {
      return item[label];
    }
  }
}
